/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLabels } from '@/hooks/useLabels';
import { View, Text } from '@az/starc-ui';
import styles from './styles.module.scss';

export type ReviewAuthorInfoProps = {
  reviewer: string | null;
  vehicleQuestion: string | null;
  vehicleAnswer: string | null;
};

const labelMap = {
  anonymous: 'label_reviews_anonymous',
};

export const ReviewAuthorInfo = ({
  reviewer,
  vehicleAnswer,
  vehicleQuestion,
}: ReviewAuthorInfoProps) => {
  const labels = useLabels(labelMap);

  return (
    <View align="start">
      <Text
        as="span"
        className={styles.text}
        attributes={{
          'data-testid': 'reviewer',
        }}
      >{`${reviewer ?? labels.anonymous}`}</Text>

      {!!vehicleQuestion && (
        <Text
          as="p"
          className={styles.vehicleAnswer}
          variant="subtitle-regular"
          color="600"
          attributes={{ 'data-testid': 'vehicle' }}
        >
          {vehicleAnswer}
        </Text>
      )}
    </View>
  );
};
